import * as React from "react";
import { Button } from "semantic-ui-react";

import { SharedDocumentsMessage } from "../../shareDocuments/components/SharedDocumentsMessage";

import { ActionableTaskButtonProps } from "./ActionableTaskButtons";

export const AssociateSentMessageAndDocumentsTaskButton: React.FunctionComponent<ActionableTaskButtonProps> = (props: ActionableTaskButtonProps) => {

    const [modalOpen, setModalOpen] = React.useState<boolean>(false);

    const onViewClicked = () => setModalOpen(true);

    return (
        <>
            {modalOpen && <SharedDocumentsMessage ohCaseId={props.task.caseId} taskId={props.task.id} onCancel={() => setModalOpen(false)} />}
            <Button secondary content="View" onClick={onViewClicked} />
        </>
    );
};
